export default {
  baseUrl: process.env.REACT_APP_BASE_URL,
  socket: process.env.REACT_APP_SOCKET,
  logo: process.env.REACT_APP_LOGO,
  secondary: process.env.REACT_APP_SECONDARY,
  primary: process.env.REACT_APP_PRIMARY,
  font: process.env.REACT_APP_FONT,
  fontName: process.env.REACT_APP_FONTNAME,
  company: process.env.REACT_APP_COMPANY,
  uploaded: process.env.REACT_APP_UPLOADED,
  favicon: process.env.FAVICON_URL
};
